import React, { useState } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { IconButton } from '@material-ui/core'
import { ReactComponent as Bin } from 'assets/img/bin.svg'
import { Flex } from 'components/common/styles'
import { deleteSignature } from 'reducers/profile/reducer'
import ConfirmDialog from 'components/common/Popup/ConfirmDialog'
import { ImageContainer, IconButtonContainer } from './SignatureField.styles'
import messages from '../translate'
import { SignatureFieldProps } from './SignatureField.types'

export const SignatureFieldComponent = ({
  signatureUrl,
  deleteSignature,
  intl: { formatMessage },
  maxHeight = '36px',
  maxWidth = '36px',
}: SignatureFieldProps) => {
  const [isOpenDeleteSignature, setIsOpenDeleteSignature] = useState(false)

  return (
    <>
      <Flex align="center">
        <ImageContainer maxHeight={maxHeight} maxWidth={maxWidth}>
          <img src={signatureUrl} alt="profile signature" />
        </ImageContainer>
        <IconButtonContainer>
          <IconButton
            size="small"
            aria-label="delete signature"
            onClick={() => setIsOpenDeleteSignature(true)}>
            <Bin />
          </IconButton>
        </IconButtonContainer>
      </Flex>
      <ConfirmDialog
        // @ts-expect-error ConfirmDialog is JS file
        open={isOpenDeleteSignature}
        cancel={{
          color: 'default',
          variant: 'outlined',
          customText: formatMessage(messages.cancel),
        }}
        confirm={{
          color: 'scales-secondary',
          customText: formatMessage(messages.delete),
        }}
        onClose={() => setIsOpenDeleteSignature(false)}
        onConfirmAction={() => {
          deleteSignature({
            successMessage: formatMessage(messages.deleteSuccessMessage),
          })
        }}
        className="dialog-primary-custom"
        title={`${formatMessage(messages.delete)} ${formatMessage(
          messages.signature,
        ).toLowerCase()}`}
        message={formatMessage(messages.deleteSignatureMessage)}
      />
    </>
  )
}

export default connect(null, {
  deleteSignature,
})(injectIntl(SignatureFieldComponent))
